import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuthStore } from './authStore.js';

interface FromState {
  from?: { pathname?: string };
}

/**
 * The inverse gate: keeps a signed-in user off the login and register screens,
 * returning them to wherever `RequireAuth` originally intercepted them.
 */
export function RedirectIfAuthenticated() {
  const status = useAuthStore((state) => state.status);
  const location = useLocation();

  if (status === 'loading') {
    return <div className="centered muted">Checking your session…</div>;
  }

  if (status === 'authenticated') {
    const state = location.state as FromState | null;
    return <Navigate to={state?.from?.pathname ?? '/'} replace />;
  }

  return <Outlet />;
}
